import React from 'react'
import cx from 'classnames'

import s from './Section.scss'


const CartSection = ({ children, className }) => (
  <div className={cx(className, s.section)}>
    {children}
  </div>
)


export default React.memo(CartSection)
